import React from 'react';
import { ArrowRight } from 'lucide-react';
import TripCountdown from '../TripCountdown/TripCountdown';
import PurpleWhiteButton from '../PurpleWhiteButton/PurpleWhiteButton';
import './RequestBanner.css';

const RequestBanner = ({ onRequestClick }) => {
  return (
    <section className="request-banner" id="request-banner">
      <img
        src="/assets/images/banner-bg.webp"
        alt=""
        className="request-banner-bg"
        fetchpriority="high"
        aria-hidden="true"
      />
      <div className="request-banner-content">
        <div className="request-banner-text">
          <h1 className="request-banner-title">ORDERS CLOSING IN...</h1>
          <div className="request-banner-countdown request-banner-countdown-inline">
            <TripCountdown />
          </div>
          <div className="request-banner-stats">
            <div className="request-stat-item">
              <span className="request-stat-number">700+</span>
              <span className="request-stat-label">Requests Taken</span>
            </div>
            <div className="request-stat-divider"></div>
            <div className="request-stat-item">
              <span className="request-stat-number">400+</span>
              <span className="request-stat-label">Customers</span>
            </div>
          </div>
          <PurpleWhiteButton to="/request-item" text="Send a Request" />
        </div>
        <div className="request-banner-countdown request-banner-countdown-aside">
          <TripCountdown />
        </div>
      </div>
    </section>
  );
};

export default RequestBanner;
